import axios from 'axios';

// Reference to the Redux store. Populated in store.js via setStore.
let store;
export const setStore = (_store) => {
  store = _store;
};

// Create a pre-configured Axios instance
// - Base URL comes from the environment
// - Requests time out after 10 seconds
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000,
});

// Maximum number of retry attempts for a request
const MAX_RETRIES = 3;

// Attach the Authorization header with the Bearer token on every request
axiosInstance.interceptors.request.use(
  (config) => {
    if (!store) return config;
    const token = store.getState().auth.token;
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle responses and implement retry logic
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response, code } = error;

    // Log out the user if the server responds with 401 Unauthorized
    // if (response?.status === 401 && store) {
    //   store.dispatch({ type: 'auth/logOut' });
    // }

    // Determine if the request should be retried
    const isNetworkError = !response && code !== 'ECONNABORTED';
    const isTimeout = code === 'ECONNABORTED';
    const isServerError = response && response.status >= 500 && response.status < 600;
    const shouldRetry = isNetworkError || isTimeout || isServerError;

    if (shouldRetry && config) {
      config.__retryCount = config.__retryCount || 0;
      if (config.__retryCount < MAX_RETRIES) {
        config.__retryCount += 1;
        // Exponential backoff: 1s, 2s, 4s
        const delay = Math.pow(2, config.__retryCount - 1) * 1000;
        await new Promise((resolve) => setTimeout(resolve, delay));
        return axiosInstance(config);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;